import { Suspense } from '@common/components/utility';
import { IWellnessExamSalesItem } from '@common/models';
import { SalesItemType } from '@common/models/Enums';
import { SalesItemService } from '@common/services';
import { formatCurrency, htmlFrom } from '@common/utils';
import { isEmpty, orderBy } from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import { Table } from 'react-bootstrap';
import { PulseLoader } from 'react-spinners';

interface IPriceCheckDiscountTable {
  items: IWellnessExamSalesItem[];
}
export const PriceCheckDiscountTable = observer(
  ({ items }: IPriceCheckDiscountTable) => {
    return (
      <Suspense
        tag={SalesItemService.tags.fetchSalesItems}
        waiting={<PulseLoader />}
      >
        <div className="table-frozen-header mt-1" style={{ height: '20rem' }}>
          <Table hover size="sm" style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th>DESCRIPTION</th>
                <th
                  className="text-start"
                  style={{ width: '15rem', paddingRight: '2rem' }}
                >
                  SKU
                </th>
                <th className="text-start" style={{ width: '5rem' }}>
                  PRICE
                </th>
              </tr>
            </thead>
            <tbody>
              {isEmpty(items) && (
                <tr>
                  <td>No sales packages found.</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              )}
              {!isEmpty(items) &&
                orderBy(items, ['name', 'sortOrder']).map((item, index) => {
                  return (
                    <tr key={`sales-package-${item.salesItemId}-${index}`}>
                      <td
                        className="text-start"
                        style={{ verticalAlign: 'top', paddingRight: '2rem' }}
                      >
                        {htmlFrom(item.name)} {htmlFrom(item.option)}
                      </td>
                      <td
                        className="text-start"
                        style={{ verticalAlign: 'top', paddingRight: '2rem' }}
                      >
                        {htmlFrom(item.hospitalSKU ?? '')}
                      </td>
                      <td
                        className="text-start"
                        style={{ verticalAlign: 'top' }}
                      >
                        {item.salesItemTypeId !==
                        SalesItemType.CouponDiscountPercentage
                          ? formatCurrency(item.price)
                          : `${item.price * 100}%`}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </Suspense>
    );
  },
);
